module.exports = __webpack_public_path__ + "static/Karla-Italic-363d3c4ec8cb40d863cdacfc0049eb12.ttf";